
interface TourItineraryProps {
  itinerary: Array<{
    time: string;
    title: string;
    desc: string;
  }>;
}

export default function TourItinerary({ itinerary }: TourItineraryProps) {
  return (
    <section className="py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-3 h-3 bg-[#1A237E] rotate-45"></span>
            <span className="text-sm font-bold text-[#1A237E] tracking-wider">ITINERARY</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900">상세 일정</h2>
        </div>

        <div className="relative max-w-3xl mx-auto">
          <div className="absolute left-[22px] top-4 bottom-4 w-0.5 bg-[#00BCD4]/20"></div>

          <div className="space-y-8">
            {itinerary.map((item, idx) => (
              <div key={idx} className="flex gap-6 relative">
                <div className="flex-shrink-0 w-11 h-11 rounded-full bg-[#00BCD4] flex items-center justify-center text-white text-xs font-bold z-10 shadow-md">
                  {idx + 1}
                </div>
                <div className="flex-1 bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="px-3 py-1 bg-[#E0F7FA] text-[#00BCD4] text-xs font-bold rounded-full whitespace-nowrap">{item.time}</span>
                    <h3 className="text-lg font-bold text-gray-900">{item.title}</h3>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
